
import React, { useCallback, useState } from "react";
import "./MaPagePublicite.css";
import ScenarioPublicite from "../ScenarioPublicite";
const apiUrl = process.env.REACT_APP_API_URL;


const INFOS_PUBLICITE = {
  nom_produit: "Intereseaux",
  description:
    "Une plateforme de mise en relation entre entreprises, indépendants et prestataires professionnels.",
  public_cible: "Entreprises et indépendants",
  objectif: "Obtenir de nouvelles inscriptions",
  ton: "Moderne, dynamique et rassurant",
  duree_secondes: 30,
  format: "vertical 9:16 pour les réseaux sociaux",
  avantages: [
    "Recherche de prestataires",
    "Mise en relation professionnelle"
  ],
  appel_action: "Inscrivez-vous dès maintenant",
  contraintes: [
    "Ne pas inventer de chiffres",
    "Éviter les promesses non vérifiées"
  ]
};

export default function MaPagePublicite() {
  const [reponseApi, setReponseApi] = useState(null);
  const [chargement, setChargement] = useState(false);
  const [erreur, setErreur] = useState("");

  const genererScenario = useCallback(async () => {
    setChargement(true);
    setErreur("");

    try {
      const response = await fetch(apiUrl+"/api/createVideo/genererScenario", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        // Si ton API utilise un token Bearer, ajoute :
        // Authorization: `Bearer ${token}`,
        body: JSON.stringify(INFOS_PUBLICITE)
      });

      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(
          data.error || `Erreur API (${response.status})`
        );
      }

      if (!data.scenario?.scenes?.length) {
        throw new Error(
          "La réponse de l'API ne contient pas de scénario valide."
        );
      }

      setReponseApi(data);
    } catch (error) {
      console.error("Erreur de génération :", error);
      setErreur(
        error.message ||
          "Impossible de générer le scénario. Réessaie."
      );
    } finally {
      setChargement(false);
    }
  }, []);

  return (
    <div className="page-publicite">
      <header className="page-publicite-header">
        <div>
          <h1>Création de publicité</h1>
          <p>
            Génère un scénario vidéo publicitaire avec l'IA.
          </p>
        </div>

        <button
          type="button"
          className="btn-generer"
          onClick={genererScenario}
          disabled={chargement}
        >
          {chargement ? (
            <>
              <span className="spinner" />
              Génération en cours…
            </>
          ) : reponseApi ? (
            "↻ Régénérer le scénario"
          ) : (
            "✦ Générer le scénario"
          )}
        </button>
      </header>

      {erreur && (
        <div className="erreur-api" role="alert">
          <p>{erreur}</p>
          <button
            type="button"
            onClick={genererScenario}
            disabled={chargement}
          >
            Réessayer
          </button>
        </div>
      )}

      {chargement && !reponseApi && (
        <div className="chargement-scenario" aria-live="polite">
          <span className="spinner spinner-large" />
          <h2>Création de ton scénario…</h2>
          <p>
            L'IA prépare le concept, les scènes et les prompts vidéo.
          </p>
        </div>
      )}

      {!chargement && !reponseApi && !erreur && (
        <div className="scenario-vide">
          <h2>Prêt à créer ta publicité ?</h2>
          <p>
            Clique sur « Générer le scénario » pour commencer.
          </p>
        </div>
      )}

      {reponseApi && (
        <section
          className={chargement ? "scenario-resultat en-cours" : "scenario-resultat"}
          aria-busy={chargement}
        >
          {chargement && (
            <div className="banniere-regeneration" aria-live="polite">
              <span className="spinner" />
              Génération d'un nouveau scénario…
              <span className="ancien-scenario">
                L'ancien scénario reste affiché jusqu'au résultat.
              </span>
            </div>
          )}

          <ScenarioPublicite
            key={JSON.stringify(reponseApi.scenario.titre)}
            data={reponseApi}
          />
        </section>
      )}
    </div>
  );
}
